/**
 * Who sees "Client portal" in the user menu. Staff can open any company's bookings there; a
 * client needs at least one company (a membership) for the portal to show them anything, so
 * a client with none would only reach "No productions yet" and the item is hidden for them.
 */
export function canOpenClientPortal({ isInternal, companies }: {
  isInternal: boolean;
  companies: ReadonlyArray<unknown> | null | undefined;
}): boolean {
  return isInternal || (Array.isArray(companies) && companies.length > 0);
}
